module.exports = __webpack_public_path__ + "media/components/Sponsors/Layouts/SideMenu/homeIcon-9ac45d329ebafb5d14901af9f0624fa2.svg";